import { FilterCriteria } from './chargepoints-page.component';

export interface PredefinedFilter {
  id: string;
  name: string;
  description?: string;
  criteria: FilterCriteria | null;
}

export const PREDEFINED_FILTERS: PredefinedFilter[] = [
  {
    id: 'last_month_to_yesterday',
    name: 'Disconnected this month',
    description: 'Show chargepoints with heartbeat between one month ago and yesterday',
    criteria: {
      operator: 'AND',
      conditions: [
        {
          field: 'lastHeartbeat',
          operator: 'greaterThanOrEqual',
          value: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString()
        },
        {
          field: 'lastHeartbeat',
          operator: 'lessThanOrEqual',
          value: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString()
        }
      ]
    }
  },
  {
    id: 'unreachable',
    name: 'Unreachable chargepoints',
    description: 'Show chargepoints that are unreachable or have no heartbeat',
    criteria: {
      operator: 'OR',
      conditions: [
        {
          field: 'status',
          operator: 'equals',
          value: 'UNREACHABLE'
        },
        {
          field: 'lastHeartbeat',
          operator: 'isNull',
          value: null
        }
      ]
    }
  },
  {
    id: 'active',
    name: 'Active chargepoints',
    description: 'Show chargepoints currently in use (charging, preparing, finishing)',
    criteria: {
      operator: 'OR',
      conditions: [
        {
          field: 'status',
          operator: 'equals',
          value: 'CHARGING'
        },
        {
          field: 'status',
          operator: 'equals',
          value: 'PREPARING'
        },
        {
          field: 'status',
          operator: 'equals',
          value: 'FINISHING'
        }
      ]
    }
  },
  {
    id: 'available',
    name: 'Available chargepoints',
    description: 'Show chargepoints that are available for use',
    criteria: {
      operator: 'AND',
      conditions: [
        {
          field: 'status',
          operator: 'equals',
          value: 'AVAILABLE'
        },
        {
          field: 'lastHeartbeat',
          operator: 'isNotNull',
          value: null
        }
      ]
    }
  },
  {
    id: 'recent_issues',
    name: 'Recent issues',
    description: 'Show chargepoints with problems in the last 7 days',
    criteria: {
      operator: 'OR',
      conditions: [
        {
          field: 'status',
          operator: 'equals',
          value: 'UNREACHABLE'
        },
        {
          field: 'status',
          operator: 'equals',
          value: 'CONFIGURING'
        },
        {
          field: 'lastHeartbeat',
          operator: 'lessThan',
          value: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString()
        }
      ]
    }
  },
];

// Fonction utilitaire pour obtenir un filtre par son ID
export function getFilterById(id: string): PredefinedFilter | undefined {
  return PREDEFINED_FILTERS.find(filter => filter.id === id);
}

// Fonction utilitaire pour obtenir tous les filtres
export function getAllFilters(): PredefinedFilter[] {
  return PREDEFINED_FILTERS;
}

// Fonction utilitaire pour créer un filtre personnalisé
export function createCustomFilter(
  id: string, 
  name: string, 
  criteria: FilterCriteria, 
  description?: string
): PredefinedFilter {
  return {
    id,
    name,
    description,
    criteria
  };
}
